module.exports = {
  configPurchaseService: require('./config.js'),
  restorePurchaseService: require('./restore.js')
};